import useCrmEnrichmentQuotaQuery from "../queries/useCrmEnrichmentQuotaQuery";

const useCrmEnrichmentQuota = (): {
    isLoading: boolean;
    isAvailableHubspotEnrichment: boolean;
    isAvailableSalesforceEnrichment: boolean;
} => {
    const { data, isLoading } = useCrmEnrichmentQuotaQuery();

    const isAvailableHubspotEnrichment = !!data?.hubspotEnrichment.isAvailable;
    const isAvailableSalesforceEnrichment = !!data?.salesforceEnrichment.isAvailable;

    return {
        isLoading,
        isAvailableHubspotEnrichment,
        isAvailableSalesforceEnrichment,
    };
};

export default useCrmEnrichmentQuota;
